"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const _360Suites_White_svg_1 = __importDefault(require("../../../assets/images/360Suites_White.svg"));
const menu_icon_webp_1 = __importDefault(require("../../../assets/images/menu-icon.webp"));
const HeaderComponent_1 = __importDefault(require("../../../components/headerComponent/HeaderComponent"));
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
require("./LandingHeaderStyles.scss");
const ModalPortalInvestidor_1 = __importDefault(require("../modalPortalInvestidor/ModalPortalInvestidor"));
const LandingHeader = ({ scrollToRef }) => {
    const { isMobile } = (0, detectDevice_1.default)(900);
    const [menuOpened, setMenuOpened] = (0, react_1.useState)(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = (0, react_1.useState)(false);
    const closeMenu = (e) => {
        e.stopPropagation();
        if (e.currentTarget.id === 'menu') {
            return;
        }
        setMenuOpened(!menuOpened);
    };
    const showModal = () => {
        setIsLoginModalOpen(true);
    };
    const content = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "util-link" },
            react_1.default.createElement("span", { onClick: () => {
                    scrollToRef('about');
                    setMenuOpened(!menuOpened);
                } }, "Como Funciona"),
            isMobile && react_1.default.createElement("hr", { className: "mobile-separator" }),
            react_1.default.createElement("span", { onClick: () => {
                    scrollToRef('advantages');
                    setMenuOpened(!menuOpened);
                } }, "Vantagens"),
            isMobile && react_1.default.createElement("hr", { className: "mobile-separator" }),
            react_1.default.createElement("span", { onClick: () => {
                    scrollToRef('formFooter');
                    setMenuOpened(!menuOpened);
                } }, "Fale Conosco"),
            react_1.default.createElement("span", { className: "modal-open", onClick: showModal }, "Acessar o portal"),
            react_1.default.createElement(ModalPortalInvestidor_1.default, { visible: isLoginModalOpen, setIsVisible: setIsLoginModalOpen }))));
    return (react_1.default.createElement(HeaderComponent_1.default, null,
        react_1.default.createElement("div", { id: "LandingHeader" }, !isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
            content,
            react_1.default.createElement("div", { className: "portal-section" },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/", className: "portal-name" },
                    "Portal",
                    react_1.default.createElement("span", null, ` 360 Suítes`))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "mobile-header" },
                react_1.default.createElement("div", { id: "icon", onClick: closeMenu },
                    react_1.default.createElement("img", { src: menu_icon_webp_1.default, alt: "" }))),
            react_1.default.createElement("div", { id: "darkness", className: `bg-darkness ${menuOpened && 'opened-bg'}`, onClick: closeMenu },
                react_1.default.createElement("div", { id: "menu", className: "mobile-menu", onClick: closeMenu },
                    react_1.default.createElement("img", { src: _360Suites_White_svg_1.default, alt: "360-logo", className: "mobile-logo" }),
                    react_1.default.createElement("div", null,
                        content,
                        react_1.default.createElement("div", { className: "portal-section" },
                            react_1.default.createElement(react_router_dom_1.Link, { to: "/", className: "portal-name" },
                                "Portal",
                                react_1.default.createElement("span", null, ` 360 Suítes`)))))))))));
};
exports.default = LandingHeader;
